import React from "react";
import {
  Drawer,
  Box,
  useMediaQuery,
  useTheme,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DocumentPreviewer from "./DocumentPreviewer";

const PdfDrawer = ({ visible, documentId, hideModal, selectedPages }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  // Adjust drawer width based on screen size
  const drawerWidth = isSmallScreen
    ? "100%" // Full width on mobile
    : isTablet
    ? "70%" // 70% width on tablets
    : "50vw"; // 50% width on desktop

  const handleClose = () => {
    // Clean up by revoking URL when closing the drawer
    hideModal();
  };

  return (
    <Drawer
      anchor="right"
      open={visible}
      onClose={handleClose}
      variant="temporary"
      ModalProps={{
        keepMounted: true, // Better open performance on mobile
      }}
      PaperProps={{
        sx: {
          width: drawerWidth,
          maxWidth: "800px",
          right: 0,
          left: "auto",
          position: "fixed",
          "& .MuiBackdrop-root": {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      }}
      sx={{
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          maxWidth: "800px",
          boxSizing: "border-box",
          right: 0,
          left: "auto",
        },
      }}
    >
      <Box
        sx={{
          position: "sticky",
          top: 0,
          bgcolor: "background.paper",
          zIndex: 1,
          borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
          padding: "8px",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <IconButton
          onClick={handleClose}
          size="small"
          sx={{
            padding: "8px",
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      <Box sx={{ padding: "20px" }}>
        {visible && (
          <DocumentPreviewer
            key={documentId} // Key to force re-mount when drawer is toggled
            documentId={documentId}
            visible={visible}
            selectedPages={selectedPages}
          />
        )}
      </Box>
    </Drawer>
  );
};

export default PdfDrawer;